export default __webpack_public_path__ + "static/ds-theming-7b42080d76aac86d364aa2d0702ae2ab.png";